<template>
  <div class="reaction-like reaction-container">
    <div v-if="!myReaction" class="reaction-show">
      <base-icon
        :name="count == 0 ? 'favorite_border' : 'favorite'"
        size="small"
        class="caption-type"
        role="button"
        @click="like"
      />
      <span class="small-type caption-type">{{ count }}</span>
    </div>
    <div v-else class="reaction-show">
      <base-icon name="favorite" size="small" class="highlighted-icon" role="button" @click="removeReaction" />
      <span class="small-type caption-type">{{ count }}</span>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import BaseIcon from 'vuecomponents/base_icon'
import { mapActions } from 'vuex'
import IntlMixin from 'vuemixins/intl_mixin'

export default {
  components: { BaseIcon },
  mixins: [IntlMixin],
  props: ['isReactable', 'userId', 'reactionIds', 'reactions'],
  computed: {
    myReaction() {
      return this.reactionIds.filter(x => this.reactions[x].user_id === this.userId)[0]
    },
    canReact() {
      return this.isReactable
    },
    count() {
      return this.reactionIds.length
    },
  },
  methods: {
    ...mapActions('snackbars', ['setSnackbar']),
    showReactionOffNotice() {
      const message = this.__('Reactions have been disabled by the admin.')
      this.setSnackbar({ message })
    },
    publishReaction(value) {
      this.$emit('create', value)
    },
    removeReaction() {
      this.$emit('delete')
    },
    like() {
      if (this.canReact) {
        this.publishReaction(1)
      } else {
        this.showReactionOffNotice()
      }
    },
  },
}
</script>
